$(function () {
  const $slick = $("#main-slick");

  // JSTの「今」
  function nowInJST() {
    return new Date(new Date().toLocaleString("en-US", { timeZone: "Asia/Tokyo" }));
  }
  // 期間判定
  function isInRange(startISO, endISO) {
    const now = nowInJST();
    const start = new Date(startISO); 
    const end   = new Date(endISO);  
    return now >= start && now <= end;
  }
  function buildSaleDateTime(date, time, includeTimezone) {
    if (!date || !time) return "";
    const trimmedDate = date.trim();
    const trimmedTime = time.trim();
    if (!/^\d{4}-\d{2}-\d{2}$/.test(trimmedDate) || !/^\d{2}:\d{2}$/.test(trimmedTime)) return "";
    const dateTime = `${trimmedDate}T${trimmedTime}:00`;
    return includeTimezone ? `${dateTime}+09:00` : dateTime;
  }

  // ★ 1枚目だけを“初期化前”に制御
  (function controlFirstBeforeInit() {
    const saleSchedule = window.customSaleSchedule || {};
    // ここに表示させたい期間をセット（JSTで明記）
    const FIRST_START = buildSaleDateTime(saleSchedule.startDate, saleSchedule.startTime, true) || "2026-04-24T12:00:00+09:00";
    const FIRST_END   = buildSaleDateTime(saleSchedule.endDate, saleSchedule.endTime, true) || "2026-04-27T10:00:00+09:00";

    const showFirst = isInRange(FIRST_START, FIRST_END);

    if (!showFirst) {
      const $slides = $slick.children(); // li想定
      if ($slides.length > 1) {
        $slides.eq(0).remove(); // ← Slickを起動する前に1枚目を物理削除
      } else {
        // 1枚しかないのに期間外 → 全体を非表示
        $slick.closest(".fvSlider").hide();
        return; // Slick初期化もしない
      }
    }
  })();

  // ここから Slick 初期化（以降は常時表示）
  $slick.on("init", function () {
    $(".fvSlider__image").css("opacity", 1);
  });

  $slick.slick({
    autoplay: true,
    centerMode: true,
    centerPadding: "16%",
    dots: true,
    arrows: false,
    responsive: [{ breakpoint: 768, settings: { centerMode: false } }]
  });
});
